import * as A from "fp-ts/Array"
import * as F from "fp-ts/function"
import * as R from "fp-ts/Record"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isObject = (obj: any) => obj !== null && obj !== undefined && obj.constructor === Object

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isEmpty = (obj: any) => isObject(obj) && Object.entries(obj).length === 0

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isAllFieldsEmpty = (obj: any): boolean =>
    Object.entries(obj)
        .map(([_, value]) => {
            if (Array.isArray(value)) return value.every(isAllFieldsEmpty)
            return isObject(value) ? isAllFieldsEmpty(value) : !value
        })
        .every((x) => x)

export const removeProp = <T extends Record<PropertyKey, unknown>, K extends keyof T>(obj: T, prop: K): Omit<T, K> => {
    if (prop in obj) {
        const cloned = { ...obj }
        delete cloned[prop]
        return cloned
    }
    return obj
}

export const extractKeys =
    (keys: readonly string[]) =>
    <T>(obj: Record<string | number, T>) =>
        F.pipe(
            Object.entries(obj),
            A.filter(([key]) => keys.some((x) => x === key)),
            R.fromEntries,
        )
